import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, Raw, Repository } from 'typeorm';
import { AllNotificationsResponse, NotificationResponse } from '@gtpl/shared-models/hrms';
import { NotificationDTO } from './dto/notifications.dto';
import { NotificationAdapter } from './dto/notifications.adapter';
import { NotificationRequest } from './dto/notifications.request';
import { Notifications } from './notifications.entity';

@Injectable()
export class NotificationsService {

    constructor(
        @InjectRepository(Notifications)
        private repository: Repository<Notifications>,
        private adapter: NotificationAdapter,
    ){}

    // async getNotification(notificationId: number): Promise<Notifications>{
    //     const response = await this.repository.findOne({
    //         where: {notificationId: notificationId},
    //     });
    //     if(response){
    //         return response;
    //     }else{
    //         return null;
    //     }
    // }

    async getJobDescriptionWithoutRelations(jobDescription: string): Promise<Notifications> {
        // tslint:disable-next-line: typedef
        const Response = await this.repository.findOne({
          where: {jobDescription: Raw(alias => `job_description = '${jobDescription}'`)},
        });
        if (Response) {
          return Response;
        } else {
          return null;
        }
      }
    async createNotification(data: NotificationDTO, isUpdate: boolean): Promise<NotificationResponse>{
        console.log(data.status,'dto')
        try{
            if(!isUpdate){
                const entity = await this.getJobDescriptionWithoutRelations(data.jobDescription);
                if(entity){
                    throw new ErrorResponse(11104, 'JobDescription already exits');
                }
            }else{
                const NotificationsEntity = await this.getJobDescriptionWithoutRelations(data.jobDescription);
                if(NotificationsEntity){
                    if(NotificationsEntity.notificationId != data.notificationId){
                        throw new ErrorResponse(11104, 'JobDescription already exits');
                    }
                }
            }
            const convertedDto: Notifications = await this.adapter.convertDtoToEntity(data);
            const savedNotification: Notifications = await this.repository.save(convertedDto);
            const convertedNotification: NotificationDTO = await this.adapter.convertEntityToDto(savedNotification);

            if(convertedNotification){
                const response = new NotificationResponse(true, isUpdate? 11100: 11101, isUpdate? 'Notification updated successfully': 'Notification created successfully', convertedNotification);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Notification is saved but error while converting it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllNotifications(): Promise<AllNotificationsResponse>{
        try{

            const notifications: NotificationDTO[] = [];
            const entities : Notifications[] = await this.repository.find({
                order: {createdAt: 'DESC'},
            });

            if(entities.length>0){
                entities.forEach(Entity => {
                    const Notifications: NotificationDTO = this.adapter.convertEntityToDto(Entity);
                    notifications.push(Notifications); 
                });
                const response = new AllNotificationsResponse(true, 11208, 'Notifications retrieved successfully', notifications);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            return error;
        }
    }

    async getNotificationById(id: number): Promise<Notifications>{
        const response = await this.repository.findOne({
            where: {notificationId: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateNotification(req: NotificationRequest): Promise<NotificationResponse>{
        try{
            const NotificationsExists = await this.getNotificationById(req.notificationId);
            if(NotificationsExists){
                if(req.versionFlag != NotificationsExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current Notification information. Refresh and try again');
                }else{
                    const notificationstatus = await this.repository.update(
                        {notificationId: req.notificationId},
                        {isActive: req.isActive, updatedUser: req.updatedUser},
                    );
                    if(NotificationsExists.isActive){
                        if(notificationstatus.affected){
                            const response: NotificationResponse= new NotificationResponse(true, 10115, 'Notification is de-activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10111, 'Notification is already de-activated');
                        }
                    }else{
                        if(notificationstatus.affected){
                            const response: NotificationResponse = new NotificationResponse(true, 10114, 'Notification is activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10112, 'Notification is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            return error;
        }
    }

    async getAllActiveNotifications(): Promise<AllNotificationsResponse>{
        try{
            const notifications: NotificationDTO[] = [];
            const entities: Notifications[] = await this.repository.find({
                order: {notificationId: 'ASC'}, where: {isActive: true},
            });
            if(entities.length>0){
                entities.forEach(Entity => {
                    const Notifications: NotificationDTO = this.adapter.convertEntityToDto(Entity);
                    notifications.push(Notifications); 
                });
                const response = new AllNotificationsResponse(true, 11208, 'Notifications retrieved successfully', notifications);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            return error;
        }
    }
}
